import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const TimelineEditor = () => {
  const columns = [
    { key: 'date', label: 'Date', type: 'date' },
    { key: 'event_en', label: 'Event (English)', type: 'textarea' },
    { key: 'event_ms', label: 'Event (Malay)', type: 'textarea' },
  ];

  return <GenericTableEditor tableName="timeline" columns={columns} title="Timeline Manager" />;
};

export default TimelineEditor;
